// src/pages/DownloadPage.jsx
import React, { useEffect } from 'react';
import '../styles/App.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import ComingSoon from '../components/ComingSoon';

const APP_STORE_URL = {
    en: 'https://apps.apple.com/hk/app/activikid-kids-activities/id6812852298?l=en-GB',
    zh: 'https://apps.apple.com/hk/app/activikid-%E8%AA%B2%E5%A4%96%E6%B4%BB%E5%8B%95%E9%A0%90%E7%B4%84%E5%B9%B3%E5%8F%B0/id6812852298',
};

const PLAY_STORE_URL = {
    en: 'https://play.google.com/store/apps/details?id=hk.activikid&hl=en',
    zh: 'https://play.google.com/store/apps/details?id=hk.activikid&hl=zh',
};

function DownloadPage() {
    useEffect(() => {
        const ua = window.navigator.userAgent || '';
        const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && 'ontouchend' in document);
        const isAndroid = /Android/i.test(ua);

        // Only auto-redirect phones/tablets; desktop shows the QR instead.
        if (!isIOS && !isAndroid) return;

        const lang = window.location.pathname.startsWith('/hk') ? 'zh' : 'en';
        const target = isIOS ? APP_STORE_URL[lang] : PLAY_STORE_URL[lang];

        window.location.replace(target);
    }, []);

    return (
        <>
            <Navbar />
            <ComingSoon />
            <Footer />
        </>
    );
}

export default DownloadPage;
